import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=52f555fd"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"
import style0 from "./pictures.vue?vue&type=style&index=0&id=52f555fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports